module.exports = __webpack_public_path__ + "img/stray-items.aba6275b.jpg";